module.exports = __webpack_public_path__ + "static/media/logo.eb627673.svg";